'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$35() {
  this.bhq = null;
  this.bho = null;
  this.bhp = false;
  this.bhm = null;
  this.bhn = false;
  this.bhr = false;
  this.bhs = false;
  this.bhq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$35 as $c_Lpresto_PrestoRouter$$anon$35 };
$p = $c_Lpresto_PrestoRouter$$anon$35.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$35;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$35() {
}
export { $h_Lpresto_PrestoRouter$$anon$35 as $h_Lpresto_PrestoRouter$$anon$35 };
$h_Lpresto_PrestoRouter$$anon$35.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhq;
});
$p.t = (function() {
  if ((!this.bhp)) {
    this.bho = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhp = true;
  }
  return this.bho;
});
$p.ae = (function() {
  if ((!this.bhn)) {
    this.bhm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bhn = true;
  }
  return this.bhm;
});
$p.w = (function() {
  if ((!this.bhs)) {
    this.bhr = false;
    this.bhs = true;
  }
  return this.bhr;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$35 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$35, "presto.PrestoRouter$$anon$35", ({
  O0: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$35 as $d_Lpresto_PrestoRouter$$anon$35 };
//# sourceMappingURL=presto.-Presto-Router$$anon$35.js.map
